import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useState } from 'react'
import ProgressBar from "./ProgressBar";
import sendCallMeData, { CallMeData } from './services/call-me'
import store from './store'
import React from "react";
import SuperSelect from "./SuperSelect";
import whatsappIcon from "./icons/whatsapp.png"
import telegramIcon from "./icons/telegram.png"
import viberIcon from "./icons/viber.png"
import WhyBlocks from "./WhyBlocks";

const sourceOptions = [
    { value: "Whatsapp", label: "Whatsapp", icon: whatsappIcon },
    { value: "Telegram", label: "Telegram", icon: telegramIcon },
    { value: "Viber", label: "Viber", icon: viberIcon },
  ];
  


export default function CallMePage(args: any) {

    let [phone, setPhone] = useState('')
    let [phoneType, setPhoneType] = useState(sourceOptions[0].value)

    let callMeData = new CallMeData(store, phoneType, phone);

    let textInput = React.createRef<HTMLInputElement>();

    const sendMsg = () => {
        if (!callMeData.phoneType && textInput.current && textInput.current.firstChild) {
            (textInput.current.firstChild as HTMLInputElement).reportValidity();
            return;
        }

        if (!callMeData.phone)
            return;

        sendCallMeData(callMeData);
        args.sendedFeedback();

    };

    return (
        <div className="App">
            <div className="questionnaire">
                <div className="questionnaire__question">
                    <div className="call-me-page">
                        <div className="call-me-page__block">
                            <div className="call-me-page__block-content">
                                <ProgressBar percentValue={95} />
                                <div className="call-me-text call-me-text--title">Мы уже рассчитали стоимость!</div>
                                <div className="call-me-text call-me-text--description">Укажите контакты, на которые нужно прислать результаты</div>
                                <div className="call-me-text call-me-text--why">Почему нам доверяют?</div>
                                <WhyBlocks />
                            </div>
                        </div>
                        <div className="call-me-page__block">
                            <div className="call-me-page__block-content">
                                <div className="field">
                                    <label>Выберите куда вам отправить рассчет стоимости ремонта</label>
                                    <div className="field__container">
                                        <SuperSelect options={sourceOptions} onChange={(val: string) => setPhoneType(val)} />
                                    </div>
                                </div>
                                <div className="field">
                                    <label>Номер телефона</label>
                                    <div className="field__container">
                                        <PhoneInput
                                            inputProps={{
                                                required: true
                                            }}
                                            containerClass="phone-field MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-colorPrimary MuiInputBase-sizeSmall slide-input css-1tcs2i1-MuiInputBase-root-MuiInput-root"
                                            country={'ru'}
                                            inputClass="MuiInputBase-input MuiInput-input MuiInputBase-inputSizeSmall css-nz481w-MuiInputBase-input-MuiInput-input"
                                            placeholder="+7 (900) 000-00-00"
                                            value={phone}
                                            isValid={str => str.length === 11}
                                            onChange={phone => setPhone(phone)}
                                        />
                                    </div>
                                </div>

                                <div className="submit-container">
                                    <button disabled={callMeData.phone.length !== 11} type="submit"  onClick={() => { sendMsg(); }} className="button is-blicked questionnaire-navbar__button questionnaire-navbar__button_next">
                                        <span className="icon">
                                            <svg viewBox="0 0 24 24" className="mdi-icon mdi-24px">
                                                <title>mdi-checkbox-marked-circle-outline</title><path d="M20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" stroke-width="0" fill-rule="nonzero"></path>
                                            </svg>
                                        </span>
                                        Получить оценку
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

